import React, { useEffect, useRef } from "react";
import BlueBaner from "../components/main/BlueBaner";
import ContactSection from "../components/contact-us/ContactSection";
import Values from "../components/about-us/Values";
import { CONTACT_PAGE } from "../data/texts";
import Map from "../components/contact-us/Map";

const ContactUsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const data = CONTACT_PAGE;
  const mapRef = useRef(null);

  return (
    <div className="flex justify-center">
      <div className="w-full flex flex-col gap-16">
        <BlueBaner 
        title={data.title}
        text={data.desc}
        />
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-20">
          <Values />
          <div className="lg:w-2/3">
            <ContactSection />
          </div>
        </div>

        <div className="min-h-[400px] rounded-[15px] mb-5">
          <Map />
        </div>
      </div>
      <div></div>
    </div>
  );
};

export default ContactUsPage;
